/**
 * Sales landing contact and pricing.
 * Egyptian mobiles like 010xxxxxxxx become 20xxxxxxxxxx for wa.me.
 */
export function toWhatsAppDigits(raw) {
  let digits = String(raw || "").replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.startsWith("0") && digits.length === 11) {
    digits = `20${digits.slice(1)}`;
  }
  return digits;
}

export const MARKETING_WHATSAPP = toWhatsAppDigits(
  process.env.REACT_APP_WHATSAPP || "01007420535",
);

export const MARKETING_WHATSAPP_DISPLAY = "01007420535";

/** Unlisted sales page — not linked from login or the employee app. */
export const SALES_LANDING_PATH = "/ess-offer";

export const MARKETING_EMAIL = String(
  process.env.REACT_APP_MARKETING_EMAIL || "",
).trim();

export const MARKETING_PLANS = [
  {
    id: "lifetime",
    name: "شراء مدى الحياة",
    employees: "حسب حجم الشركة والفروع",
    price: "25,000 – 50,000",
    period: "جنيه — دفعة واحدة",
    setup: "تدفع مرة واحدة — بدون اشتراك شهري",
    annual: "السعر النهائي حسب عدد الموظفين والفروع",
    features: [
      "حساب شركة معزول على المنصة",
      "كل الموديولات حسب حجم الشركة",
      "ويب + تطبيق بكود الشركة",
      "تحديثات ضمن الاتفاق",
    ],
    featured: true,
    badge: "دفعة واحدة",
  },
  {
    id: "monthly",
    name: "اشتراك شهري",
    employees: "30 جنيه لكل موظف",
    price: "30",
    period: "جنيه / موظف / شهر",
    setup: "حد أدنى 1,000 جنيه شهرياً",
    annual: "أقل فاتورة شهرية 1,000 جنيه حتى لو عدد الموظفين أقل",
    features: [
      "حساب شركة معزول على المنصة",
      "تدفع حسب عدد الموظفين الفعلي",
      "ويب + تطبيق بكود الشركة",
      "زيادة أو تقليل العدد شهرياً",
    ],
    featured: false,
  },
];

export const MARKETING_PRICING_NOTE =
  "شراء مدى الحياة يبدأ من 25,000 إلى 50,000 جنيه دفعة واحدة حسب حجم الشركة. أو اشتراك 30 جنيه للموظف شهرياً بحد أدنى 1,000 جنيه شهرياً. الأسعار بالجنيه المصري.";

export function buildLeadMessage({
  companyName,
  contactName,
  employeeCount,
  phone,
  notes,
  productName,
  planName,
}) {
  const lines = [
    `طلب ديمو — ${productName || "HRMS"}`,
    planName ? `الباقة: ${planName}` : null,
    `الشركة: ${companyName || "-"}`,
    `الاسم: ${contactName || "-"}`,
    `عدد الموظفين: ${employeeCount || "-"}`,
    phone ? `رقم التواصل: ${phone}` : null,
    notes ? `ملاحظات: ${notes}` : null,
  ].filter(Boolean);
  return lines.join("\n");
}

export function buildWhatsAppUrl(message, phone = MARKETING_WHATSAPP) {
  const digits = toWhatsAppDigits(phone);
  if (!digits) return "";
  return `https://wa.me/${digits}?text=${encodeURIComponent(message || "")}`;
}

export function buildMailtoUrl(message, email = MARKETING_EMAIL) {
  const address = String(email || "").trim();
  if (!address) return "";
  return `mailto:${address}?subject=${encodeURIComponent("طلب ديمو")}&body=${encodeURIComponent(message || "")}`;
}
